// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation_item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px 0px 0px 16px;
    height: 48px;
    background: #00172F;
    font-family: 'Gibson-Regular';
}

.Navigation_text {
    cursor: pointer;
    height: 20px;
    font-family: 'Gibson-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #BBC8D1;
}`, "",{"version":3,"sources":["webpack://./src/components/ApolloReactComponent/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".Navigation_item {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 12px 0px 0px 16px;\n    height: 48px;\n    background: #00172F;\n    font-family: 'Gibson-Regular';\n}\n\n.Navigation_text {\n    cursor: pointer;\n    height: 20px;\n    font-family: 'Gibson-Regular';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #BBC8D1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
